import { ModuleSupportCenterCatalog } from '@src/api/generated/data-contracts';

export const getCategoryFirstPid = (category: ModuleSupportCenterCatalog): string | undefined => {
  if (category.children?.length) {
    return getCategoryFirstPid(category.children[0]);
  }
  return category.postId;
};

export const getArticlePath = (cateGory: ModuleSupportCenterCatalog[]): string => {
  return cateGory.map(i => i.name).join('/');
};